import { render, staticRenderFns } from "./SectionsCardA.vue?vue&type=template&id=1893d194"
import script from "./SectionsCardA.vue?vue&type=script&lang=js"
export * from "./SectionsCardA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports